import type { BasketPaymentReturnProp } from "./payment-return";

type OpenBasketCheckoutOptions = {
  businessId: string;
  apiUrl?: string;
  primaryColor?: string;
  gtagConversionId?: string;
  gtagConversionLabel?: string;
  /** Back from a Stripe redirect: the overlay finishes that order. */
  paymentReturn?: BasketPaymentReturnProp;
};

export function openBasketCheckout({
  businessId,
  apiUrl,
  primaryColor,
  gtagConversionId,
  gtagConversionLabel,
  paymentReturn,
}: OpenBasketCheckoutOptions): void {
  const existing = document.querySelector("baluu-basket-checkout-overlay");
  if (existing) existing.parentNode?.removeChild(existing);

  const create = () => {
    const overlay = document.createElement("baluu-basket-checkout-overlay");
    overlay.setAttribute("business-id", businessId);
    if (apiUrl) overlay.setAttribute("api-url", apiUrl);
    if (primaryColor) overlay.setAttribute("primary-color", primaryColor);
    if (gtagConversionId)
      overlay.setAttribute("gtag-conversion-id", gtagConversionId);
    if (gtagConversionLabel)
      overlay.setAttribute("gtag-conversion-label", gtagConversionLabel);
    if (paymentReturn)
      overlay.setAttribute("payment-return", JSON.stringify(paymentReturn));
    document.body.appendChild(overlay);
  };

  // Defer to next frame so the DOM settles after the previous overlay removal
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(create);
  } else {
    setTimeout(create, 0);
  }
}
